<div class="common-modal__container">
  <div class="common-modal__header">
    <span class="common-modal__text-header common-modal__text-header-flex-none">
      {{taskModal.title}}
    </span>
  </div>
  <div class="common-modal__content-scroll">
    @if (taskModal.chargeManagersClassificator) {
      <div class="common-modal__form-container-extend">
          <div class="common-container__mandatory-obligatory-message-form">
            <span class="common-tag__mandatory-text-asterisk">*</span>
            <span class="common-tag__mandatory-label-text-obligatory-message"
              [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
          </div>
          <field-type-text-simple [field]="taskModal.titleField"
            [preSelectItem]="taskModal.task.title"
            (itemSelected)="taskModal.task.title = $event.newValue">
          </field-type-text-simple>
          <field-type-list-extended [field]="taskModal.managerClassificationField"
            [listValues]="taskModal.managerClassificationOptions"
            [preSelectItem]="taskModal.managerClassificationSelected"
            (itemSelected)="selectManagerClassificationType($event)">
          </field-type-list-extended>
          @switch (taskModal.managerClassificationSelected) {
            @case ('1') {
              @for (state of taskModal.states; track $index) {
                <field-type-contacts [field]="state.responsibleField"
                  (sendContacts)="responsibleSelected($event, state)">
                </field-type-contacts>
              }
            }
            @case ('2') {
              <field-type-switch [field]="{label: 'process.general-task.add-confidential'| afTranslate}"
                [preSelectItem]="taskModal.task.addResponsibleToConfidentiality"
                (itemSelected)="taskModal.task.addResponsibleToConfidentiality = $event.newValue">
              </field-type-switch>
              <div class="process-task-modal__typology-block">
                @for (assign of taskModal.assignList; track $index) {
                  <div class="process-task-modal__typology-container">
                    <div class="process-task-modal__typology-header-container">
                      <span-tooltip class="process-task-modal__typology-text-header"
                        [text]="assign.name"></span-tooltip>
                      <div class="process-task-modal__typology-header-icons">
                        @if($first){
                          <i class="lf-icon-add-round concept-form__icon-subgroup"
                            (click)="duplicateSubcontainer()"
                            pTooltip="{{'subcontainer-multiple.new-entry' | afTranslate}}"
                            tooltipPosition="top"></i>
                        }@else{
                          <i class="lf-icon-trash concept-form__icon-subgroup"
                            (click)="deleteDuplicated(assign, $index)"
                            pTooltip="{{'subcontainer-multiple.delete-entry' | afTranslate}}"
                            tooltipPosition="top"></i>
                        }
                      </div>
                    </div>
                    <field-type-contacts [field]="assign.responsibleField"
                      (sendContacts)="responsibleAssignSelected($event, assign)"
                      [listDisabled]="taskModal.usersAssign">
                    </field-type-contacts>
                    <field-type-list-multiple [field]="assign.fieldListData"
                      [listValues]="assign.listValues"
                      [preSelectItem]="assign.listValueId"
                      (itemSelected)="managerOptionsList($event, assign)">
                    </field-type-list-multiple>
                  </div>
                }
              </div>
            }
            @default {
              <field-type-contacts [field]="taskModal.responsibleField"
                (sendContacts)="responsibleSelected($event, taskModal.task)">
              </field-type-contacts>
            }
          }
          <div class="process-task-modal__notifications-container">
            <field-type-switch
              [field]="{label: 'process.general-task.daily-repeat-task-notification' | afTranslate}"
              [preSelectItem]="taskModal.task.dailyRepeatIdleTaskNotification"
              [small]="true"
              (itemSelected)="taskModal.task.dailyRepeatIdleTaskNotification = $event.newValue">
            </field-type-switch>
            <field-type-switch [field]="{label: 'process.general-task.establish-expiration-task'| afTranslate}"
              [preSelectItem]="taskModal.expirationTask"
              [small]="true"
              (itemSelected)="taskModal.expirationTask = $event.newValue">
            </field-type-switch>
          </div>
          @if (taskModal.expirationTask) {
            <div class="common-radio-button-list__container-box common-radio-button-list__container-box--full">
              <div class="common-text-input__block-header">
                <p class="common-text-input__label">
                  <span class="common-text-input__text-label"
                    [afTranslate]="'process.general-task.expiration-period'">_Plazo de vencimiento
                  </span>
                  <span class="common-tag__mandatory-text-asterisk">*</span>
                </p>
              </div>
              <label for="process-next-period"
                class="common-radio-button-list__switch-option-container">
                <span class="common-radio-button-list__switch-option-text"
                  [afTranslate]="'process.general-task.process-task-expire'">
                  _La tarea de proceso vencerá por defecto
                </span>
                <input-number [preSelectValue]="taskModal.task.expirationUnits"
                  (selectedValue)="itemSelected($event, 'expirationUnits')">
                </input-number>
                <button-with-text-menu-arrow
                  [item]="taskModal.expirationTimeUnitField"
                  [list]="taskModal.frecuencyList"
                  [selectedOption]="taskModal.task.expirationTimeUnit"
                  (launchActionEmitter)="taskModal.task.expirationTimeUnit = $event.option">
                </button-with-text-menu-arrow>
                <span class="common-radio-button-list__switch-option-text"
                  [afTranslate]="'process.general-task.after-creation'">
                  _después de su creación
                </span>
              </label>
            </div>
          }
          <field-type-rich-text-editable
            [field]="taskModal.descriptionField"
            [preSelectItem]="taskModal.task.description"
            (itemSelected)="itemSelected($event, 'description')">
          </field-type-rich-text-editable>
          <div class="common-radio-button-list__container-box common-radio-button-list__container-box--full">
            <div class="common-text-input__block-header">
              <p class="common-text-input__label">
                <span class="common-text-input__text-label"
                  [afTranslate]="'process.general-task.states-label'">
                  _Estados
                </span>
              </p>
            </div>
            <div class="process-task-modal__states-block">
              @for (state of taskModal.states; track $index) {
                <div class="common-tag__state-task common-tag__state-task--blue">
                  <span-tooltip class="common-tag__state-task-text"
                  [text]="state.name"></span-tooltip>
                </div>
              }
            </div>
          </div>
      </div>
    }
  </div>
  <div class="common-modal__footer">
    <button class="common-button__text-border"
      (click)="handleDismiss()">
      <span class="common-button__text-title"
        [afTranslate]="'common.cancel'">
        _Cancelar
      </span>
    </button>
    <button class="common-button__text"
      (click)="saveTask()">
      <span class="common-button__text-title">
        {{taskModal.okButtonLabel}}
      </span>
    </button>
  </div>
</div>
